<template>
  <div class="page">
    <van-nav-bar title="统计" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="switch-box">
      <el-radio-group v-model="type" size="mini" @change="typeChange">
        <el-radio-button label="周"></el-radio-button>
        <el-radio-button label="月"></el-radio-button>
      </el-radio-group>
      <div class="date-box">
        <van-icon name="arrow-left" @click="minus" />
        <div class="date" v-if="type == '周'">{{ mondayTime }}~{{ sundayTime }}</div>
        <div class="date" v-else>{{ month }}</div>
        <van-icon name="arrow" @click="plus" />
      </div>
    </div>
    <div class="item-box" v-for="(item, index) in pageList" :key="index">
      <van-collapse v-model="activeNames">
        <van-collapse-item :name="index.toString()">
          <template #title>
            <div class="header">
              <div class="header-name">{{ item.title }}</div>
              <div class="header-value" :style="{ color: item.title == '旷工' ? '#F85352' : '#666666' }">{{ item.value }}{{ getUnits(item.title) }}</div>
            </div>
          </template>
          <div v-if="showListType(item.title) == 1">
            <div class="item-box" v-for="(child, idx) in item.contentList" :key="'idx' + idx">
              <div>{{ child.dkrq }} {{ child.dksj }}</div>
              <!-- <p>去处理</p> -->
            </div>
          </div>
          <div v-if="showListType(item.title) == 2">
            <div class="item-box" v-for="(child, idx) in item.contentList" :key="'idx2' + idx">
              <div>{{ child.dkrq }} {{ child.xq }}</div>
              <div style="color: #999999">{{ child.gs }}小时</div>
            </div>
          </div>
          <div v-if="showListType(item.title) == 3">
            <div class="item-box" v-for="(child, idx) in item.contentList" :key="'idx3' + idx">
              <div>{{ child.dkrq }} {{ child.dksj }}</div>
            </div>
          </div>
          <div v-if="showListType(item.title) == 4">
            <div class="item-box2" v-for="(child, idx) in item.contentList" :key="'idx4' + idx">
              <div>{{ child.qjsc }}天</div>
              <p>{{ child.kssj }}~{{ child.jssj }}</p>
            </div>
          </div>
          <div v-if="showListType(item.title) == 5">
            <div class="item-box2" v-for="(child, idx) in item.contentList" :key="'idx4' + idx">
              <div>{{ child.kgsc }}天</div>
              <p>{{ child.kgsj }}</p>
            </div>
          </div>
          <div v-if="showListType(item.title) == 6">
            <div class="item-box2" v-for="(child, idx) in item.contentList" :key="'idx5' + idx">
              <div>{{ child.mqsc }}天</div>
              <p>{{ child.kssj }}~{{ child.jssj }}</p>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import iApi from '@/utils/internship'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      activeNames: [],
      type: '月',
      weekIndex: 0,
      monthIndex: 0,
      // nowTime: new Date().getTime(),
      weekday: new Date().getDay(),
      oneDayTime: 24 * 60 * 60 * 1000,
      oneWeekTime: 7 * 24 * 60 * 60 * 1000,
      mondayTime: '',
      sundayTime: '',
      month: '',
      form: {
        sxjhid: '',
        date: '',
        ksrq: '',
        jsrq: '',
      },
      pageList: [],
    }
  },
  computed: {
    showListType() {
      return item => {
        let list = ['迟到次数', '早退']
        let list1 = ['签到次数', '外勤']
        if (list.includes(item)) {
          return 1
        } else if (item == '平均工时') {
          return 2
        } else if (list1.includes(item)) {
          return 3
        } else if (item == '旷工') {
          return 5
        } else if (item == '免签') {
          return 6
        }
        return 4
      }
    },
    // 获取单位
    getUnits() {
      return item => {
        let list1 = ['平均工时']
        let list2 = ['签到次数', '迟到', '早退', '外勤']
        let list3 = ['旷工', '请假', '免签']
        if (list1.includes(item)) {
          return '小时'
        } else if (list2.includes(item)) {
          return '次'
        } else if (list3.includes(item)) {
          return '天'
        }
        return ''
      }
    },
    ...mapGetters({
      sxjhid: 'getSxjhid',
    }),
  },
  methods: {
    plus() {
      if (this.type == '月') {
        this.getMonth('plus')
      } else {
        this.weekIndex += 1
        this.getWeekDate()
      }
    },
    minus() {
      if (this.type == '月') {
        this.getMonth('minus')
      } else {
        this.weekIndex -= 1
        this.getWeekDate()
      }
    },
    typeChange(e) {
      // 切换到月务必清空周日历
      if (e == '月') {
        this.form.ksrq = ''
        this.form.jsrq = ''
        this.month = new Date().format('yyyy.MM')
        this.form.date = new Date().format('yyyy-MM')
        this.getData()
      } else {
        this.form.date = ''
        this.getWeekDate()
      }
    },
    getWeekDate() {
      let nowTime = new Date().getTime() + this.weekIndex * this.oneWeekTime
      this.mondayTime = new Date(nowTime - (this.weekday - 1) * this.oneDayTime).format('MM.dd') // 周一日期
      this.sundayTime = new Date(nowTime + (7 - this.weekday) * this.oneDayTime).format('MM.dd') // 周日日期
      this.form.ksrq = new Date(nowTime - (this.weekday - 1) * this.oneDayTime).format('yyyy-MM-dd') // 周一日期
      this.form.jsrq = new Date(nowTime + (7 - this.weekday) * this.oneDayTime).format('yyyy-MM-dd') // 周日日期
      this.getData()
    },
    getMonth(type) {
      let year = parseInt(this.month.split('.')[0])
      let month = parseInt(this.month.split('.')[1])
      if (type == 'plus') {
        month += 1
        if (month == 13) {
          month = 1
          year += 1
        }
      } else {
        month -= 1
        if (month == 0) {
          month = 12
          year -= 1
        }
      }
      this.month = year + '.' + (month < 10 ? '0' + month : month)
      this.form.date = year + '-' + (month < 10 ? '0' + month : month)
      this.getData()
    },
    async getData() {
      this.form.sxjhid = this.sxjhid
      const res = await iApi.getAttendanceTotal(this.form)
      // res.data.splice(0, 1)
      this.pageList = res.data
    },
  },
  created() {
    if (this.type == '周') {
      this.getWeekDate()
    } else {
      this.month = new Date().format('yyyy.MM')
      this.form.date = new Date().format('yyyy-MM')
      this.getData()
    }
  },
}
</script>

<style lang="less" scoped>
.page {
  background: #f2f2f4;
  min-height: 100vh;
  margin-top: -50px;
}
.switch-box {
  // width: 100%;
  height: 50px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  .date-box {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .date {
      margin: 0 5px;
    }
    i {
      color: #b2b2b2;
    }
  }
}

.item-box {
  width: 345px;
  min-height: 50px;
  background: #ffffff;
  border-radius: 8px;
  margin: 10px auto;
  overflow: hidden;
  .header {
    display: flex;
    justify-content: space-between;
    .header-name {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
  }
  .item-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #e5e5e5;
    div {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
    p {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #0088f8;
    }
  }
  .item-box2 {
    height: 50px;
    border-bottom: 1px solid #e5e5e5;
    div {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
    p {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/statistics.vue